import { Button } from "antd";
import Error from "@components/global/new/Error/Error";
import { Input } from "@components/global/new/Input/Input";
import SmallLink from "@components/global/new/SmallLink/SmallLink";
import { useIntl } from "react-intl";
import { useLoginControl } from "@components/Pages/Login/useLoginControl";
import styles from "./LandingAuthCard.module.scss";
import cn from 'classnames';
import { Link, NavLink } from "react-router-dom";
import Checkbox from "@components/global/new/Checkbox/Checkbox";
import { IS_DEBUG, REACT_RECAPTCH_KEY } from "../../../../config";
import useMediaQuery from "@utils/hooks/utils";
import ReCAPTCHA from "react-google-recaptcha";

interface AuthFormProps {
  control: ReturnType<typeof useLoginControl>;
}

function RegistrationForm({
  control,
}: AuthFormProps): JSX.Element {

  const { formatMessage } = useIntl();
  const isXs = useMediaQuery("max", 574);
  const isNarrowPhone = useMediaQuery("max", 370);

  return (
    <section className={cn(styles.card, styles.registration, {
      [styles.show]: control.isSign,
    })}>
      <div className={styles.header}>
        <h3>{formatMessage({ id: "registration.title" })}</h3>
        <p>
          {formatMessage({ id: "registration.already" })}{" "}
          <SmallLink onClick={control.changeWindow}>
            {formatMessage({ id: "login.title" })}
          </SmallLink>
        </p>
      </div>
      <form className={styles.form} onSubmit={control.create}>
        <Input
          label={formatMessage({ id: "registration.email" })}
          size="large"
          colored
          outlined
          name="email"
          placeholder="manager@wattlord.io"
          type="email"
          wrapClassName={styles.field}
        />
        <Input
          inputType="password"
          label={formatMessage({ id: "registration.password" })}
          size="large"
          type="password"
          colored
          outlined
          name="password"
          placeholder="********"
          wrapClassName={styles.field}
        />
        <Input
          inputType="password"
          label={formatMessage({ id: "registration.repeat" })}
          size="large"
          type="password"
          colored
          outlined
          name="repeat"
          placeholder="********"
          wrapClassName={styles.field}
        />
        <div className={styles.terms}>
          <Checkbox
            checked={control.terms}
            onClick={control.changeTerms}
            isError={!control.terms && control.errors?.terms}
          />
          <p
            className={cn({
              [styles.term_error]: !control.terms && control.errors?.terms,
            })}
          >
            {formatMessage(
              { id: "registration.policy" },
              {
                link: (
                  <Link
                    to='/terms'
                    target='_blank'
                    rel='noopener noreferrer'
                    className={styles.terms_link}
                  >
                    {formatMessage({ id: "registration.policy.link" })}
                  </Link>
                ),
              }
            )}
          </p>
        </div>
        {REACT_RECAPTCH_KEY && !IS_DEBUG && (
          <div
            className={cn("g-recaptcha", styles.recaptcha, {
              [styles.xsRecaptcha]: isXs,
              [styles.compactRecaptcha]: isNarrowPhone,
            })}
          >
            <ReCAPTCHA
              sitekey={REACT_RECAPTCH_KEY}
              size={isNarrowPhone ? "compact" : "normal"}
              onChange={(response) =>
                response && control.setRecaptchaResponse(response)
              }
              onExpired={() => control.setRecaptchaResponse(undefined)}
              ref={control.reCapRefRegister}
            />
          </div>
        )}
        {control.errors && <Error errors={control.errors} />}
        <Button
          htmlType="submit"
          type="primary"
          loading={control.loading}
          className={styles.submit}
        >
          {formatMessage({ id: "registration.btn" })}
        </Button>
      </form>
    </section>
  );
}

function LoginForm({
  control,
}: AuthFormProps): JSX.Element {

  const { formatMessage } = useIntl();

  return (
    <section className={cn(styles.card, styles.login, {
      [styles.show]: !control.isSign,
    })}>
      <div className={styles.header}>
        <h3>{formatMessage({ id: "login.title" })}</h3>
        <p>{formatMessage({ id: "wlp.auth.description" })}</p>
      </div>
      <form className={styles.form} onSubmit={control.login}>
        <Input
          label={formatMessage({ id: "login.email" })}
          size="large"
          colored
          outlined
          name="email"
          placeholder="manager@wattlord.io"
          type="email"
          wrapClassName={styles.field}
        />
        <Input
          inputType="password"
          label={formatMessage({ id: "login.password" })}
          size="large"
          type="password"
          colored
          outlined
          name="password"
          placeholder="********"
          wrapClassName={styles.field}
        />
        {control.errors && <Error errors={control.errors} />}
        <Button
          htmlType="submit"
          type="primary"
          loading={control.loading}
          className={styles.submit}
        >
          {formatMessage({ id: "login.btn" })}
        </Button>
        <SmallLink className={styles.forgot} onClick={control.openForgot}>
          {formatMessage({ id: "login.forgot" })}
        </SmallLink>
        <SmallLink className={styles.forgot} onClick={control.openSignup}>
          {formatMessage({ id: "menu.sign" })}
        </SmallLink>
        {/* <SmallLink className={styles.forgot} onClick={control.openForgot}>
          {formatMessage({ id: "menu.sign" })}
        </SmallLink> */}
      </form>
    </section>
  );
}

function LandingAuthCard() {

  const control = useLoginControl();

  return (
    <div className={styles.wrapper}>
      <LoginForm control={control} />
      <RegistrationForm control={control} />
    </div>
  );
  // <section className={styles.card}>
  //   <div className={styles.header}>
  //     <h3>{formatMessage({ id: "login.title" })}</h3>
  //     <p>{formatMessage({ id: "wlp.auth.description" })}</p>
  //   </div>
  //   <form className={styles.form} onSubmit={control.login}>
  //     <Input
  //       label={formatMessage({ id: "login.email" })}
  //       size="large"
  //       colored
  //       outlined
  //       name="email"
  //       placeholder="manager@wattlord.io"
  //       type="email"
  //       wrapClassName={styles.field}
  //     />
  //     <Input
  //       inputType="password"
  //       label={formatMessage({ id: "login.password" })}
  //       size="large"
  //       type="password"
  //       colored
  //       outlined
  //       name="password"
  //       placeholder="********"
  //       wrapClassName={styles.field}
  //     />
  //     {control.errors && <Error errors={control.errors} />}
  //     <Button
  //       htmlType="submit"
  //       type="primary"
  //       loading={control.loading}
  //       className={styles.submit}
  //     >
  //       {formatMessage({ id: "login.btn" })}
  //     </Button>
  //     <SmallLink className={styles.forgot} onClick={control.openForgot}>
  //       {formatMessage({ id: "login.forgot" })}
  //     </SmallLink>
  //   </form>
  // </section>
}

export { LandingAuthCard };
